import React, {  useEffect, useRef, useState } from "react";
import spotlightLogo from "../../assets/SpotlightLogo.svg";
import notification_icon from "../../assets/notification-icon.svg";
import default_avatar from "../../assets/default-avatar.jpg";
import cross from "../../assets/cross.png";
import "./Header.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as actions from "../../Redux/Actions/index";
import { showErrorToastMessage } from "../Toasts/Toasts";
import { useSelector } from "react-redux";
import moment from "moment";
import { Form } from "react-bootstrap";
import { BiPowerOff } from "react-icons/bi";
import useLoadingIndicator from "../Loader/Loader";
import hamburger_icon from "../../assets/sidebaricons/hamburger-menu.svg";
import { baseUrl } from "../../config/constants";
import { Strings } from "../../constant/Strings";

const Header = (props: any) => {
  const {OldNotifications,NewNotifications,NoNotificationsfound,Logout} = Strings
  const { loadingComponent, showLoadingIndicator, hideLoadingIndicator } =
    useLoadingIndicator();
  const { handleSideBar } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userLogin: any = localStorage.getItem("login");
  const loginId = JSON.parse(userLogin)?.id;

  const logout = () => {
    if (baseUrl?.includes("spotlight-dev-api.skill-mine.com")) {
      localStorage.clear();
      (window.location.href = "https://spotlight-dev.skill-mine.com/"),
        "_blank";
    } else if (baseUrl?.includes("spotlight-api.skill-mine.com")) {
      localStorage.clear();
      (window.location.href = "https://spotlight.skill-mine.com/"), "_blank";
    } else if (
      baseUrl?.includes("https://spotlight-stage-api.skill-mine.com")
    ) {
      localStorage.clear();
      (window.location.href = "https://spotlight-stage.skill-mine.com/"),
        "_blank";
    } else {
      dispatch(actions.logOutAction("logout"));
    }
  };

  const [showLogout, setShowLogout] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [allNotificationArray, setAllNotificationArray] = useState<any>([]);
  const [readArray, setReadNotificationArray] = useState<any>([]);
  const [unReadArray, setUnreadNotificationArray] = useState<any>([]);
  const [onSwitch, setOnSwitch] = useState(false);
  const [unReadCount, setUnreadNotificationCount] = useState<any>("");
  const [displayPicture, setdisplayPicture] = React.useState(null);

  const editEmployeeDetails = useSelector(
    (state: any) => state.employeeReducer.editEmployeeData
  );
  const getApiDispatch = () => {
    dispatch(
      actions.getemployeeDetailsAction(loginId, (res: any) => {
        if (res?.error?.error_description) {
          showErrorToastMessage(res?.error?.error_description);
        } else {
          if (res?.code === 200) {
            setdisplayPicture(
              res.data?.[0]?.candidatePhoto?.document_path_url
                ? res.data?.[0]?.candidatePhoto?.document_path_url
                : res.data?.[0]?.candidatePhoto?.candidatePhoto?.document_path_url
                ? res.data?.[0]?.candidatePhoto?.candidatePhoto?.document_path_url
                : ""
            );
            hideLoadingIndicator();
          }
        }
      })
    );
  };
  useEffect(() => {
    showLoadingIndicator();
    getApiDispatch();
  }, [loginId]);

  useEffect(() => {
    getApiDispatch();
  }, [editEmployeeDetails]);


  useEffect(() => {
    dispatch(actions.getAllNotificationAction());
  }, [unReadCount]);

  const getAllNotification = useSelector(
    (state: any) => state.employeeReducer.getAllNotification
  );

  useEffect(() => {
    if (getAllNotification && getAllNotification.data) {
      setAllNotificationArray(getAllNotification.data.allNotificationList);
      setReadNotificationArray(getAllNotification.data.readNotificationList);
      setUnreadNotificationArray(getAllNotification.data.newNotificationList);
      setUnreadNotificationCount(getAllNotification.data.unreadMessagesCount);
    }
  }, [getAllNotification, allNotificationArray, readArray, unReadArray]);

  const handleClick = () => {
    dispatch(actions.getAllNotificationAction());
    setShowNotification(true);
  };

  const myRef: any = useRef();

  const onClickUnreadSubject = (notificationId: any, employeeId: any) => {
    dispatch(
      actions.editNotificationDataAction(notificationId, { is_Read: 1 })
    );
    dispatch(actions.getAllNotificationAction());
    dispatch(actions.getemployeeDetailsAction(employeeId, (res: any) => {}));
    localStorage.setItem("selectedId", employeeId);
    localStorage.setItem("fromSearch", JSON.stringify(true));
    setShowNotification(false);
    navigate("/");
  };

  const onClickReadSubject = (employeeId: any) => {
    showLoadingIndicator();
    dispatch(actions.getemployeeDetailsAction(employeeId, (res: any) => {}));
    localStorage.setItem("selectedId", employeeId);
    localStorage.setItem("fromSearch", JSON.stringify(true));
    setShowNotification(false);
    navigate("/");
    hideLoadingIndicator();
  };

  return (
    <div className="header">
      <div onClick={handleSideBar}>
        <img src={hamburger_icon} alt="icon" />
      </div>
      {loadingComponent()}
      <div onClick={() => navigate("/profile")}>
        <img
          src={spotlightLogo}
          className="spotlight-logo"
          alt="spotlightLogo"
          data-toggle="tooltip"
          data-placement="top"
          title="click here to navigate to your profile"
        />
      </div>

      <div className="header-logos">
        <div
          className="sorting-cursor pwd-container"
          onClick={handleClick}
          ref={myRef}
        >
          <div className="btn-container">
            <button className="btn">
              <img
                src={notification_icon}
                className="notification_icon"
                alt="icon"
              />
            </button>
          </div>
          {unReadArray.length > 0 && <span className="notification-dot"></span>}
        </div>

        {
          <div
            className={
              showNotification
                ? "notification-list show-notification"
                : "notification-list"
            }
          >
            <div className="notification-div">
              <span>
                <div className="row">
                  <div className="col-11">
                    {onSwitch ? (
                      <strong className="notification-title">
                       {OldNotifications}
                      </strong>
                    ) : (
                      <strong className="notification-title">
                        {NewNotifications}
                        <span className="notification-size">
                          ({unReadCount})
                        </span>
                      </strong>
                    )}
                  </div>
                  <div className="col-1">
                    <img
                      className="notification-close"
                      onClick={() => setShowNotification(false)}
                      src={cross}
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Close"
                      alt="icon"
                    />
                  </div>
                </div>
              </span>
            </div>
            <div className="toggle-switch">
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={onSwitch}
                className="switch"
                onChange={() => setOnSwitch(!onSwitch)}
              />
            </div>
            {onSwitch ? (
              readArray.length == 0 ? (
                <>
                  <div className="align-center-text">
                    {NoNotificationsfound}
                  </div>
                </>
              ) : (
                readArray.map((ele: any, index: any) => (
                  <React.Fragment key={index}>
                    <div className="notification-subject">
                      <ul key={ele?.subject}>
                        <li>
                          <div
                            onClick={() =>
                              onClickReadSubject(ele.redirect_to_user_id)
                            }
                          >
                            {ele?.subject}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="notification">
                      <p>{ele?.message}</p>
                      <div className="d-flex">
                        {moment(ele?.created_at).format("DD-MMM-YYYY")}
                        <div className="notification-time">
                          {moment(ele?.created_at).format("h:mm a")}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              )
            ) : unReadArray.length == 0 ? (
              <>
                <div className="align-center-text">{NoNotificationsfound}</div>
              </>
            ) : (
              unReadArray.map((ele: any, index: any) => (
                <React.Fragment key={index}>
                  <div className="notification-subject">
                    <ul>
                      <li>
                        <div
                          onClick={() =>
                            onClickUnreadSubject(
                              ele?._id,
                              ele.redirect_to_user_id
                            )
                          }
                        >
                          {ele?.subject}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="notification">
                    <p>{ele?.message}</p>
                    <div className="d-flex">
                      {moment(ele?.created_at).format("DD-MMM-YYYY")}
                      <div className="notification-time">
                        {moment(ele?.created_at).format("h:mm a")}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))
            )}
          </div>
        }

        <div className="btn-container">
          <button
            className="btn"
            onMouseOver={() => setShowLogout(true)}
            onMouseLeave={() => setShowLogout(false)}
          >
            <img
              src={displayPicture ? displayPicture : default_avatar}
              className="image-profile"
              height="100%"
              width="100%"
              alt="icon"
            />
          </button>
          <div
            className={showLogout ? "dropdown show-dropdown notification-size" : "dropdown notification-size"}
            onMouseOver={() => setShowLogout(true)}
            onMouseLeave={() => setShowLogout(false)}
          >
            <button className="dropdown-btn" onClick={logout}>
              <BiPowerOff className="icon-user logout-icon"></BiPowerOff> {Logout}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
